const s = () => {
  const e = (r) => !(r.name.indexOf("#t=") >= 0 || r.name.indexOf("?t=") >= 0);
  window.performance._getEntriesByName || (window.performance._getEntriesByName = window.performance.getEntriesByName, window.performance.getEntriesByName = (...r) => window.performance._getEntriesByName(...r).filter(e)), window.performance._getEntries || (window.performance._getEntries = window.performance.getEntries, window.performance.getEntries = () => window.performance._getEntries().filter(e)), window.performance._getEntriesByType || (window.performance._getEntriesByType = window.performance.getEntriesByType, window.performance.getEntriesByType = (...r) => window.performance._getEntriesByType(...r).filter(e));
}, f = (e, r = "") => {
  let n = new URLSearchParams();
  window.location.hash.indexOf(`${e}=`) >= 0 ? n = new URLSearchParams("?" + window.location.hash.substr(1)) : window.location.search.indexOf(`${e}=`) >= 0 && (n = new URLSearchParams(window.location.search));
  var t = n.get(e);
  return t || r;
}, w = () => window.location.hash.includes("t=");
var a = {}, o = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
a.validate = function(e) {
  if (!e || e.length > 254)
    return !1;
  var r = o.test(e);
  if (!r)
    return !1;
  var n = e.split("@");
  if (n[0].length > 64)
    return !1;
  var t = n[1].split(".");
  return !t.some(function(i) {
    return i.length > 63;
  });
};
const c = (e, r) => r === "email" ? !a.validate(e.trim()) : e.trim().length === 0, d = "foobar";
export {
  s as filterTokensFromPerformance,
  d as foobar,
  f as getUrlParam,
  w as tokenInUrl,
  c as validateInput
};
//# sourceMappingURL=index.es.js.map
